import {
  Directive,
  HostListener,
  ElementRef
} from "@angular/core";
import { FormGroupDirective } from "@angular/forms";
import { fromEvent, timer } from "rxjs";
import { debounceTime, delay, take, tap } from "rxjs/operators";

@Directive({
  selector: '[appInvalidControlScroll]'
})
export class InvalidControlScrollDirective {

  constructor(
    private el: ElementRef,
    private formGroupDir: FormGroupDirective,
  ) {}

  @HostListener("ngSubmit") onSubmit() {
    if (this.formGroupDir.control.invalid) {
      this.scrollToFirstInvalidControl();
    }
  }

   scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      ".ng-invalid"
    );
      firstInvalidControl.focus()
  }

   getTopcolOffset(controlEl: HTMLElement): number {
    const labelcolOffset = 50;
    const res = controlEl.getBoundingClientRect().top + window.scrollY - labelcolOffset
    return res;
  }

}
